module.exports = __webpack_public_path__ + "static/media/aiva_logo_large.f89ed2fe.jpg";